{
    "organization": {
        "breadcrumb": "Administratie",
        "notification": {
            "noSufficientPermissions": "Niet voldoende rechten om deze pagina te openen."
        },
        "enabled": "Actief",
        "disabled": "Deaktiviert",
        "edit": "Veranderen",
        "disable": "Deactiveren",
        "delete": "Verwijderen",
        "add": "Toevoegen",
        "save": "Opslaan {{name}}",
        "cancel": "Afbreken",
        "enable": "Aktivieren",
        "confirmation": {
            "cancel": "AFBREKEN",
            "confirm": "BEVESTIGEN",
            "disable": "DEACTIVEREN",
            "delete": "VERWIJDEREN"
        }
    },
    "orgUnit" : {
        "name":"Naam",
        "active":"Status",
        "distributionAgreements":"Bestaande distributieovereenkomsten"
    },
    "orgUser": {
        "header": "Alle gebruikers ({{count}})",
        "disabled": "(disabled)",
        "displayUid": "ID",
        "uid": "ID",
        "active": "Status",
        "name": "Naam",
        "firstName": "Voornaam",
        "lastName": "Achternaam",
        "email": "Email",
        "orgUnit": "Eenheid",
        "unit": "Unit",
        "deliveryAddress": "Verzendadres",
        "standardShippingMethod": "Standaard verzendwijze",
        "roles": "Roles",
        "title": "Titel",
        "hint": "Alle gebruikers",
        "unitApprover": "Unit approver",
        "assignApprover": "Add the user to approvers for the unit",
        "actions": "",
        "sortBy": "Sortieren",
        "sort": {
            "byName": "Sorteren op naam",
            "byUnit": "Sorteren op ID"
        },
        "details": {
            "title": "Gebruikersdetails",
            "subtitle": "Gebruiker: {{ item.name }}"
        },
        "edit": {
            "title": "Bewerk gebruiker",
            "subtitle": "Gebruiker: {{ item.name }}"
        },
        "create": {
            "title": "Aanmaken Gebruiker",
            "subtitle": ""
        },
        "links": {
            "password": "Wachtwoord veranderen",
            "approvers": "Approvers",
            "userGroup": "User groups",
            "permission": "Purchase limits"
        },
        "messages": {
            "deactivateTitle": "Deze gebruiker uitschakelen?",
            "deactivate": "Gehandicapte gebruikers kunnen niet inloggen op de etalage en bestellingen plaatsen.",
            "confirmEnabled": "User {{item.firstName}} {{item.lastName}} enabled successfully",
            "confirmDisabled": "User {{item.firstName}} {{item.lastName}} disabled successfully",
            "update": "Gebruiker {{item.firstName}} {{item.lastName}} wsuccesvol geactualiseerd.",
            "create": "Gebruiker {{item.firstName}} {{item.lastName}} succesvol geregistreerd",
            "updatePassword": " Het wachtwoord is succesvol gewijzigd voor gebruiker {{item.firstName}} {{item.lastName}}.",
            "deleteCurrentUser":"U heeft geen toestemming om deze actie uit te voeren. Neem contact op met uw beheerder als u denkt dat dit een fout is."
        },
        "info": {
            "disabledEdit": "Bearbeitungsmodus ist nur möglich, wenn Sie den Benutzer aktivieren",
            "disabledEnable": "Unit must be enabled before this user may be enabled."
        },
        "approver": {
            "link": "Approvers",
            "header": "Approvers in {{code}}",
            "assign": "Assign Approvers",
            "assignHeader": "Assign Approvers in {{code}}",
            "back": "Back",
            "new": "New approver",
            "instructions": {
                "check": "To assign an approver to this user, select the user's check box.",
                "uncheck": "To remove an approver, clear the user's check box.",
                "changes": "Changes are saved automatically."
            }
        },
        "userGroup": {
            "link": "User groups",
            "header": "User groups in {{code}}",
            "assign": "Assign user groups",
            "assignHeader": "Assign user groups in {{code}}",
            "back": "Back",
            "instructions": {
                "check": "To assign an user group to this user, select the user's check box.",
                "uncheck": "To remove aa user group, clear the user's check box.",
                "changes": "Changes are saved automatically."
            }
        },
        "permission": {
            "title": "Bevoegdheden",
            "accessSubject": {
                "userType": "User type",
                "cart": "Cart",
                "orderHistory": "Order history",
                "deliveryNotes": "Pakbonnen",
                "invoicesOverview": "Invoices overview",
                "stockProtection": "Stock protection",
                "statistics": "Statistics",
                "ownVk": "Own VK",
                "forum": "Forum",
                "bestPrice": "Best price"
            },
            "view": "view",
            "edit": "edit",
            "link": "Purchase limits",
            "header": "Purchase limits in {{code}}",
            "assign": "Assign purchase limits",
            "assignHeader": "Assign purchase limits in {{code}}",
            "back": "Back",
            "instructions": {
                "check": "To assign a purchase limits to this user, select its check box.",
                "uncheck": "To unassign a purchase limits, clear its check box.",
                "changes": "Changes are saved automatically."
            },
            "per": {
                "undefined": "",
                "MONTH": "per Month",
                "YEAR": "per Year",
                "WEEK": "per Week",
                "QUARTER": "per Quarter"
            }
        },
        "password": {
            "title": "Wachtwoord veranderen",
            "subtitle": "Gebruiker: {{ item.email }}",
            "newPassword": "Nieuw wachtwoord",
            "confirmPassword": "Herhaal nieuw wachtwoord"
        },
        "breadcrumbs": {
            "list": "Alle gebruikers",
            "details": "{{name}}",
            "userGroups": "User groups",
            "approvers": "Approvers",
            "permissions": "Purchase limits"
        }
    }
}
